'use strict';

const sentry = require('./analytics/sentry');
sentry.init();

const $ = window.jQuery;
const universalGA = require('./analytics/googleAnalyticsEvents');
const analytics = require('./analytics');
const genbar = require('./genbar/generationBar');
const magicbar = require('./magicbar/magicBar');
const simpleTooltip = require('./helpers/simpleTooltip');
const appNavigation = require('./helpers/appNavigation');
const $body = $('body');
const simplePopover = require('./helpers/simplePopover');
const { initLazyImages } = require('./helpers/lazyImages');

// Analytics
universalGA.init();
analytics.init();

// Define placeholder for the mustache templates
window.mustacheTemplates = {};

// Boostrap JS extended
require('./bootstrap-extended/animations');
require('./bootstrap-extended/tooltip-closer');

genbar.init();
if ($('.magic-bar').length > 0) {
  magicbar.init();
}

appNavigation();

window.isMobile = window.isMobile || false;

// fix cors for ie ?
$.support.cors = true;

if (typeof window.moment !== 'undefined') {
  window.moment.locale(window.wooGlobal.language);
}

initLazyImages({
  loadImmediately: $body.hasClass('pdf')
});

// Jquery Plugins
require('./jquery-plugins/externalLinks');
require('./jquery-plugins/truncate');
require('./jquery-plugins/formatTime');
require('./jquery-plugins/prettyTextOverflow');

// Helpers
require('./helpers/topNavigationBar');
require('./helpers/validateForm');
require('./helpers/toggleAccordion');
require('./helpers/wooPopover');
require('./helpers/contactSupport');

if ($body.hasClass('home')) {
  require('./helpers/homepageScroll');
}

if ($body.hasClass('feature-highlight')) {
  require('./modals/createAdvancedReview');
}

if ($body.hasClass('gaprofiles') || $body.hasClass('settings')) {
  require('./settings/settings');
}

if ($body.hasClass('overview')) {
  require('./overview/overview');
  require('./bootstrap-extended/popover-closer');
}

if ($body.hasClass('user')) {
  require('./user/cancelSubscription');
  require('./user/toggleInvoices');
  require('./login/login');
}

if ($body.hasClass('subusers')) {
  require('./subusers/subusers');
}

if ($body.hasClass('review')) {
  require('./review/review');
  require('./modals/deleteReview');
  require('./bootstrap-extended/popover-closer');
}

if ($body.hasClass('generating')) {
  require('./generate-socket/generateSocket');
}

if ($body.hasClass('pdf')) {
  require('./pdf/pdf');
}

if ($body.hasClass('pricing')) {
  require('./pricing/pricing');
  require('./g-recaptcha/recaptchaOnload');
}

if ($body.hasClass('login')) {
  require('./login/login');
  require('./login/loginWithQuestions');
  require('./g-recaptcha/recaptchaOnload');
}

if ($body.hasClass('forgot-password')) {
  require('./login/login');
}

if ($body.hasClass('register')) {
  require('./register/register');
}

if ($body.hasClass('update-billing-details')) {
  require('./register/updateBillingDetails');
}

if ($body.hasClass('plans')) {
  require('./plans/plans');
}

if ($body.hasClass('js-sync-popup')) {
  require('./components/form-list');
}

if ($body.hasClass('pdf-editor')) {
  require('./pdf-editor/pdf-editor');
}

if ($body.hasClass('error')) {
  require('./review/error');
}

if ($body.hasClass('first-generation-review-confirmation')) {
  require('./review/firstGenerationReview');
}

universalGA.bind();

simpleTooltip();
simplePopover();

require('./helpers/jsLoadEnd');
